'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { RotateCcw, Home, AlertTriangle } from 'lucide-react';
import { useT } from '@/hooks/useT';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useT();
  useEffect(() => { console.error(error); }, [error]);

  return (
    <div style={{
      minHeight: '72vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '48px 20px', position: 'relative', overflow: 'hidden',
    }}>
      <div aria-hidden style={{
        position: 'absolute', width: 560, height: 560, borderRadius: '50%',
        background: 'radial-gradient(circle, color-mix(in srgb, var(--gs-red) 18%, transparent), transparent 68%)',
        filter: 'blur(44px)', pointerEvents: 'none',
      }} />
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
        <div style={{
          width: 96, height: 96, borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'color-mix(in srgb, var(--gs-red) 12%, transparent)',
          border: '1px solid color-mix(in srgb, var(--gs-red) 30%, transparent)',
          color: 'var(--gs-red)',
        }}>
          <AlertTriangle size={44} strokeWidth={1.8} />
        </div>
        <h1 style={{
          fontSize: 'clamp(20px, 4vw, 28px)', fontWeight: 800, color: 'var(--fg)', margin: 0,
          fontFamily: "'Space Grotesk', sans-serif",
        }}>{t('err_title')}</h1>
        <p style={{ fontSize: 15, color: 'var(--fg-3)', maxWidth: 400, margin: 0, lineHeight: 1.65, textWrap: 'balance' }}>
          {t('err_desc')}
        </p>
        {error?.digest && (
          <code style={{ fontSize: 11, color: 'var(--fg-4)', fontFamily: 'monospace', opacity: .7 }}>
            #{error.digest}
          </code>
        )}
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', marginTop: 10 }}>
          <button onClick={reset} className="gs-cta"><RotateCcw size={16} />{t('err_retry')}</button>
          <Link href="/" className="gs-cta-ghost"><Home size={16} />{t('nf_home')}</Link>
        </div>
      </div>
    </div>
  );
}
